import styled from 'styled-components';

// theme
import aampeTheme from '../../constants/aampeTheme';

const EmptyStateText = styled.span(() => ({
    fontSize: aampeTheme.size.font.default,
    color: aampeTheme.colors.textAccessibleWG01,
    fontWeight: 400,
}));

export default EmptyStateText;
